import React from 'react';
import DailyDeviationIndicator from '@wix/da-ds/pkg/Indicators/DailyDeviationIndicator';
import DeviationFlag from '@wix/da-ds/pkg/Indicators/DeviationFlag';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import deviationFlagStyles from './DeviationFlags.scss';
export const DeviationFlagBase = ({ innerRef, title })=>{
    const dd_and_hype_banners = useFlag('dd_and_hype_banners');
    return /*#__PURE__*/ React.createElement("div", {
        ref: innerRef,
        className: deviationFlagStyles['base']
    }, dd_and_hype_banners ? /*#__PURE__*/ React.createElement(DeviationFlag, {
        variant: "daily-deviation",
        size: "large",
        className: deviationFlagStyles['flag']
    }) : /*#__PURE__*/ React.createElement(DailyDeviationIndicator, {
        size: "large",
        className: deviationFlagStyles['flag']
    }), /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['collapsed-title']
    }, title));
};
DeviationFlagBase.displayName = 'DeviationFlagBase';
export default DeviationFlagBase;
